import styled from 'styled-components';

export const ColorPickerContainer = styled.div`
  position: relative;
`;

export const ColorInputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  background: white;
`;

export const ColorCode = styled.input`
  flex: 1;
  border: none;
  padding: 0 8px;
  font-size: 0.8125rem;
  color: #1e1e1e;
  background: transparent;
  min-width: 90px;
  
  &:focus {
    outline: none;
  }
`;

export const ColorSquare = styled.button`
  width: 60px;
  height: 30px;
  border: none;
  border-left: 1px solid #ddd;
  background: ${props => props.color};
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    pointer-events: none;
  }
`;

export const ColorPickerPopover = styled.div`
  position: fixed;
  z-index: 9000;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 12px;
  width: auto;
  cursor: move;
  user-select: none;
`;

export const ColorPickerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 220px;

  .react-colorful {
    width: 100% !important;
    height: 150px !important;
  }

  .react-colorful__saturation-pointer {
    width: 12px !important;
    height: 12px !important;
  }

  .react-colorful__hue-pointer,
  .react-colorful__alpha-pointer {
    width: 12px !important;
    height: 12px !important;
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  margin: -12px -12px 8px -12px;
  border-bottom: 1px solid #eee;
  cursor: move;
  background: #f5f5f5;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  color: #666;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background: #e0e0e0;
    color: #333;
  }
`;

export const ColorSwitcher = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const ColorTypeButton = styled.button`
  flex: 1;
  padding: 0.25rem 0.5rem;
  background: ${props => props.active ? '#1e1e1e' : 'transparent'};
  color: ${props => props.active ? '#fff' : '#1e1e1e'};
  border: 1px solid ${props => props.active ? '#1e1e1e' : '#ddd'};
  border-radius: 4px;
  font-size: 0.8125rem;
  cursor: pointer;
  
  &:hover {
    background: ${props => props.active ? '#1e1e1e' : '#f5f5f5'};
  }
`;

export const GradientStops = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StopsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`;

export const StopItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  background: #f5f5f5;
  border-radius: 4px;
`;

export const StopColor = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: ${props => props.color};
  cursor: pointer;
  border: 1px solid #ddd;
`;

export const StopPercentage = styled.input`
  width: 40px;
  height: 24px;
  padding: 0 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.8125rem;
  text-align: right;
`;

export const StopActions = styled.div`
  display: flex;
  gap: 4px;
  margin-left: auto;
`;

export const StopButton = styled.button`
  width: 24px;
  height: 24px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
  
  &:hover {
    background: #f5f5f5;
    color: #333;
  }
`;

export const AngleInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const AngleControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  background: #f5f5f5;
  border-radius: 4px;
  width: 100%;
`;

export const AngleLabel = styled.span`
  font-size: 0.8125rem;
  color: #666;
  white-space: nowrap;
`;

export const AngleValue = styled.input`
  width: 70px;
  height: 24px;
  padding: 0 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.8125rem;
  text-align: right;

  &::-webkit-inner-spin-button {
    opacity: 1;
  }

  &:focus {
    outline: none;
    border-color: #4AE66E;
  }
`;

export const GradientTypeWrapper = styled.div`
  position: relative;
  width: 100%;

  .select-icon {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
    pointer-events: none;
    transition: transform 0.1s ease;
  }

  &:focus-within .select-icon {
    transform: translateY(-50%) rotate(90deg);
  }
`;

export const GradientTypeSelect = styled.select`
  width: 100%;
  height: 24px;
  padding: 0 2rem 0 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.8125rem;
  background: white;
  cursor: pointer;
  appearance: none;

  &:focus {
    outline: none;
    border-color: #4AE66E;
  }
`;

export const AngleUnitWrapper = styled.div`
  position: relative;

  .select-icon {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
    pointer-events: none;
    transition: transform 0.1s ease;
  }

  &:focus-within .select-icon {
    transform: translateY(-50%) rotate(90deg);
  }
`;

export const AngleUnitSelect = styled.select`
  height: 24px;
  padding: 0 2rem 0 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.8125rem;
  background: white;
  cursor: pointer;
  min-width: 90px;
  appearance: none;

  &:focus {
    outline: none;
    border-color: #4AE66E;
  }
`; 